<div id="reports-list-modal" class="common-popup-view">
    <div class="popoup-hearder">
        <h2 class="m-b-5" mat-dialog-title>Derivar a mutua</h2>
    </div>

        <div class="popoup-content">
            <div class="block-looper-wrapper">
                <div class="fuse-card auto-width m-b-5 mat-elevation-z2 p-0 acuation-card-border t-m-2  custHei">
                    <div fxLayout="row" fxLayoutAlign="start center" class="custHei">
                       <div class="menuSelectOption" fxFlex fxLayout="row" fxLayoutAlign="start center">
                          <mat-label><strong>Empresa</strong></mat-label>
                          <app-tree-view [origin]="1" (companyNode)="onChangeCompany($event)"></app-tree-view>             
                       </div>
                    </div>
                 </div>
            </div>
        </div>
        <div class="popoup-footer">
            <button mat-button color="primary" class="keep" (click)="onSubmit()"><span
                    class="mat-button-wrapper unset-position">Aceptar
                    
                </span></button>
            <button mat-button color="accent" class="cancel" (click)="close()"><span
                    class="mat-button-wrapper unset-position">Cancelar</span></button>
        </div>
</div>